import React from "react";
import {useState,useEffect} from "react";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Calendar} from "primereact/calendar";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Tag} from "primereact/tag";
import Message from "../Helpers/Message.js";
import {fetch_url_post, format_date} from "../../Sources/js/app.js";
import {get_api_path} from "../../Sources/js/paths.js";

let oper = "";

let defaultInputValues = {
	id: null,
	nr_intern: "",
	data_primirii: null,
	furnizor: "",
	nr_factura: "",
	valoare: 0,
	tva: 0,
	total: 0,
	observatii: "",
};

let defaultDataValues = {
	registruList: [],
};

let defaultDialogValues = {
	openAddEdit: false,
	titleAddEdit: "",
};

const RegistruIntrari = (props) => {

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [blockScreen, setBlockScreen] = useState(false);
	const [filterText, setFilterText] = useState("");
	const [filterYear, setFilterYear] = useState(new Date().getFullYear().toString());
	const [unitData, setUnitData] = useState({});
	const [selectedRows, setSelectedRows] = useState([]);
	const [xmlPeriod, setXmlPeriod] = useState("7");

	const handleChange = evt => {
		const {name, value} = evt.target;
		setInputValues({...inputValues, [name]: value});
	}

	const handleCalendarChange = (name, value) => {
		setInputValues({...inputValues, [name]: value});
	}

	const handleNumberChange = (name, value) => {
		setInputValues({...inputValues, [name]: value});
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(result.ok === 0) {
			setMessageText("Eroare: " + result.error);
			return false;
		}
		if(result.is_auth === 0) {
			window.location.href = "/login";
			return false;
		}
		if(result.message) {
			setMessageText(result.message);
		}
		if(oper === "getRegistruIntrari" || oper === "saveRegistruIntrare" || oper === "deleteRegistruIntrare") {
			setDataValues({...dataValues, registruList: result.registruList || []});
			if(result.unitData) setUnitData(result.unitData);
		}
		if(oper === "saveRegistruIntrare") {
			setDialogValues({...dialogValues, openAddEdit: false});
		}
		setDataOk(true);
		oper = "";
	}

	const fail_handler = () => {
		setBlockScreen(false);
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	useEffect(() => {
		loadData();
	}, []);

	const loadData = () => {
		oper = "getRegistruIntrari";
		let url = "getRegistruIntrari?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, {filter_text: filterText, filter_year: filterYear}, success_handler, fail_handler);
	}

	const handleFilter = () => {
		loadData();
	}

	const handleAddNew = () => {
		setInputValues({...defaultInputValues, data_primirii: new Date()});
		setDialogValues({
			openAddEdit: true,
			titleAddEdit: "Adaugare inregistrare noua",
		});
	}

	const handleEdit = (row) => {
		// Parse date from dd-mm-yyyy
		let dateParts = row.data_primirii ? row.data_primirii.split("-") : null;
		let dateObj = dateParts ? new Date(dateParts[2], dateParts[1] - 1, dateParts[0]) : null;
		setInputValues({
			id: row.id,
			nr_intern: row.nr_intern,
			data_primirii: dateObj,
			furnizor: row.furnizor,
			nr_factura: row.nr_factura,
			valoare: parseFloat(row.valoare) || 0,
			tva: parseFloat(row.tva) || 0,
			total: parseFloat(row.total) || 0,
			observatii: row.observatii || "",
		});
		setDialogValues({
			openAddEdit: true,
			titleAddEdit: "Modificare inregistrare #" + row.nr_intern,
		});
	}

	const handleDelete = (row) => {
		confirmDialog({
			message: "Confirmati stergerea inregistrarii " + row.nr_intern + " ?",
			header: "Confirmare stergere",
			icon: "pi pi-exclamation-triangle",
			acceptLabel: "Da, sterge",
			rejectLabel: "Nu",
			accept: () => {
				oper = "deleteRegistruIntrare";
				let url = "deleteRegistruIntrare?session_id=" + props.session.sessId;
				setBlockScreen(true);
				fetch_url_post(url, {id: row.id}, success_handler, fail_handler);
			}
		});
	}

	const handleSave = () => {
		if(!inputValues.data_primirii) {
			setMessageText("Completati data primirii facturii!");
			return;
		}
		if(!inputValues.furnizor.trim()) {
			setMessageText("Completati furnizorul!");
			return;
		}
		if(!inputValues.nr_factura.trim()) {
			setMessageText("Completati numarul facturii furnizorului!");
			return;
		}
		// Format date to dd-mm-yyyy
		let d = inputValues.data_primirii;
		let dateStr = d instanceof Date
			? String(d.getDate()).padStart(2,"0") + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + d.getFullYear()
			: inputValues.data_primirii;

		let dataToSend = {
			...inputValues,
			data_primirii: dateStr,
		};

		oper = "saveRegistruIntrare";
		let url = "saveRegistruIntrare?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, dataToSend, success_handler, fail_handler);
	}

	const tvaAutoCalc = () => {
		if(inputValues.valoare && inputValues.tva) {
			let total = parseFloat(inputValues.valoare) + parseFloat(inputValues.tva);
			setInputValues({...inputValues, total: Math.round(total * 100) / 100});
		}
	}

	// Computed filtered list (client-side quick filter)
	const filteredList = dataValues.registruList;

	const buildFacturaHtml = (row, f) => {
		const items = f.items || [];
		const tvaDetalii = f.tva_detalii || [];
		const instructiuni = f.instructiuni_plata || [];
		const fmt = (v) => parseFloat(v||0).toFixed(2);
		const td = (label, val, bold) => `<tr><td style="padding:3px 6px;font-size:12px;color:#555">${label}</td><td style="padding:3px 6px;font-size:12px${bold?';font-weight:bold':''}">${val||''}</td></tr>`;
		const hasFact = !!f.numar_factura;

			// Supplier block
			const vanzatorHtml = hasFact ? `
<div style="flex:1;min-width:220px">
  <div style="font-weight:bold;font-size:13px;border-bottom:1px solid #333;margin-bottom:4px">VANZATOR</div>
  <table style="border:none;font-size:12px"><tbody>
    ${td('Nume', f.furnizor)}
    ${f.furnizor_reg ? td('Nr. inregistrare', f.furnizor_reg) : ''}
    ${f.furnizor_capital ? td('Informatii juridice', f.furnizor_capital) : ''}
    ${f.furnizor ? td('Denumire', f.furnizor) : ''}
    ${f.furnizor_cui ? td('Nr. inregistrare fiscala', f.furnizor_cui) : ''}
    ${f.furnizor_strada ? td('Strada', f.furnizor_strada) : ''}
    ${f.furnizor_oras ? td('Oras', f.furnizor_oras) : ''}
    ${td('Cod', f.furnizor_cod||'')}
    ${f.furnizor_regiune ? td('Regiun', f.furnizor_regiune) : ''}
    ${f.furnizor_tara ? td('Tara', f.furnizor_tara) : ''}
    ${f.furnizor_tel ? td('Telefon', f.furnizor_tel) : ''}
    ${f.furnizor_email ? td('E-mail', f.furnizor_email) : ''}
  </tbody></table>
</div>` : `<div style="flex:1"><b>Furnizor:</b> ${row.furnizor||'-'}</div>`;

			// Buyer block
			const cumparatorHtml = hasFact ? `
<div style="flex:1;min-width:220px">
  <div style="font-weight:bold;font-size:13px;border-bottom:1px solid #333;margin-bottom:4px">CUMPARATOR</div>
  <table style="border:none;font-size:12px"><tbody>
    ${td('Nume', f.cumparator)}
    ${f.cumparator_cui||f.cumparator_reg ? td('Nr. inregistrare', f.cumparator_cui||f.cumparator_reg) : ''}
    ${f.cumparator ? td('Denumire', f.cumparator) : ''}
    ${td('Identificat', f.cumparator_identificat||'-//-')}
    ${f.cumparator_strada ? td('Strada', f.cumparator_strada) : ''}
    ${f.cumparator_oras ? td('Oras', f.cumparator_oras) : ''}
    ${td('Cod', f.cumparator_cod||'')}
    ${f.cumparator_regiune ? td('Regiune', f.cumparator_regiune) : ''}
    ${f.cumparator_tara ? td('Tara', f.cumparator_tara) : ''}
  </tbody></table>
</div>` : '';

			// Invoice center block
			const facturaCentruHtml = hasFact ? `
<div style="flex:0 0 220px;text-align:center">
  <div style="font-size:18px;font-weight:bold;margin-bottom:10px">RO eFactura</div>
  <table style="border:none;font-size:12px;margin:0 auto"><tbody>
    ${td('Nr. factura', f.numar_factura)}
    ${f.tip_factura ? td('Codul tipului', f.tip_factura) : ''}
    ${td('Data emitere', f.data_factura)}
    ${f.data_scadenta ? td('Data scadenta', f.data_scadenta) : ''}
    ${td('Moneda facturii', f.moneda)}
    ${f.moneda_contab && f.moneda_contab!==f.moneda ? td('Moneda contabilizare', f.moneda_contab) : ''}
  </tbody></table>
</div>` : `<div style="flex:0 0 180px;text-align:center"><b>Nr. factura:</b><br/>${row.nr_factura||'-'}</div>`;

			// Totals summary table
			const totaluriHtml = `
<table style="width:100%;border-collapse:collapse;margin-top:12px;font-size:12px">
  <thead><tr style="background:#f0f0f0">
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">TOTAL NET</th>
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">VALOARE TOTALA<br/>fara TVA</th>
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">VALOARE TOTALA<br/>cu TVA</th>
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">TOTAL DEDUCERI</th>
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">TOTAL TAXE<br/>SUPLIMENTARE</th>
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">SUMA PLATITA</th>
    <th style="padding:5px 6px;border:1px solid #ccc;text-align:center">VALOARE DE<br/>ROTUNJIRE</th>
  </thead>
  <tbody>
    <tr>
      <td style="padding:5px 6px;border:1px solid #ccc">${fmt(f.total_net||f.valoare)}</td>
      <td style="padding:5px 6px;border:1px solid #ccc">${fmt(f.valoare)}</td>
      <td style="padding:5px 6px;border:1px solid #ccc">${fmt(f.valoare_cu_tva||f.total)}</td>
      <td style="padding:5px 6px;border:1px solid #ccc">${f.total_deduceri?fmt(f.total_deduceri):''}</td>
      <td style="padding:5px 6px;border:1px solid #ccc">${f.total_taxe_supl?fmt(f.total_taxe_supl):''}</td>
      <td style="padding:5px 6px;border:1px solid #ccc">${f.suma_platita?fmt(f.suma_platita):''}</td>
      <td style="padding:5px 6px;border:1px solid #ccc">${f.rotunjire?fmt(f.rotunjire):''}</td>
    </tr>
    <tr>
      <td colspan="2" style="padding:5px 6px;border:1px solid #ccc;font-weight:bold">TOTAL PLATA</td>
      <td style="padding:5px 6px;border:1px solid #ccc;font-weight:bold">${fmt(f.total||row.total)}</td>
      <td colspan="4" style="border:none"></td>
    </tr>
  </tbody>
</table>`;

			// TVA section
			const tvaHtml = `
<div style="margin-top:10px">
  <b>TOTAL TVA &nbsp;&nbsp; ${fmt(f.tva||row.tva)} ${f.moneda||'RON'}</b>
  ${tvaDetalii.length > 0 ? `
  <div style="margin-top:4px;font-weight:bold;font-size:12px">Detalierea TVA</div>
  <table style="width:100%;border-collapse:collapse;font-size:12px;margin-top:4px">
    <thead><tr style="background:#f0f0f0">
      <th style="padding:4px 6px;border:1px solid #ccc">Codul categoriei</th>
      <th style="padding:4px 6px;border:1px solid #ccc">Cota TVA</th>
      <th style="padding:4px 6px;border:1px solid #ccc">Baza de calcul</th>
      <th style="padding:4px 6px;border:1px solid #ccc">Valoare TVA</th>
      <th style="padding:4px 6px;border:1px solid #ccc">Codul motivului</th>
      <th style="padding:4px 6px;border:1px solid #ccc">Motivul scutirii</th>
    </tr></thead>
    <tbody>${tvaDetalii.map(t => `<tr>
      <td style="padding:4px 6px;border:1px solid #ccc">${t.cod_categorie||''}</td>
      <td style="padding:4px 6px;border:1px solid #ccc">${t.cota_tva||0}</td>
      <td style="padding:4px 6px;border:1px solid #ccc">${fmt(t.baza_calcul)}</td>
      <td style="padding:4px 6px;border:1px solid #ccc">${fmt(t.valoare_tva)}</td>
      <td style="padding:4px 6px;border:1px solid #ccc">${t.cod_motiv||''}</td>
      <td style="padding:4px 6px;border:1px solid #ccc">${t.motiv_scutire||''}</td>
    </tr>`).join('')}</tbody>
  </table>` : ''}
</div>`;

			// Line items
			const liniiHtml = items.length > 0 ? `
<table style="width:100%;border-collapse:collapse;font-size:12px;margin-top:10px">
  <thead><tr style="background:#f0f0f0">
    <th style="padding:4px 5px;border:1px solid #ccc;width:35px">Linia</th>
    <th style="padding:4px 5px;border:1px solid #ccc;text-align:left">Nume articol/Descriere articol</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:55px">Tara proven.</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:75px;text-align:right">Pretul net</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:45px">Moneda</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:55px;text-align:right">Cant. baza</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:65px;text-align:right">Cant. fact.</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:40px">UM</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:45px">Cota TVA</th>
    <th style="padding:4px 5px;border:1px solid #ccc;width:80px;text-align:right">Valoare neta</th>
  </tr></thead>
  <tbody>${items.map(l => `<tr>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:center">${l.linia||''}</td>
    <td style="padding:3px 5px;border:1px solid #ccc">${l.denumire||''}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:center">${l.tara_prov||''}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:right">${fmt(l.pret_unitar)}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:center">${l.moneda||'RON'}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:right">${l.cant_baza||1}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:right">${parseFloat(l.cantitate||0).toFixed(4)}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:center">${l.um||''}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:center">${l.tva_procent||''}</td>
    <td style="padding:3px 5px;border:1px solid #ccc;text-align:right"><b>${fmt(l.total_linie)}</b></td>
  </tr>`).join('')}</tbody>
</table>` : '';

			// Payment instructions
			const plataHtml = instructiuni.length > 0 ? `
<div style="margin-top:14px;font-size:12px">
  ${instructiuni.map(p => `
  <div style="margin-bottom:8px">
    <b>Instructiuni de plata</b><br/>
    ${p.cod_instrument ? `Nota privind instrumentul de &nbsp;&nbsp; ${p.cod_instrument}<br/>` : ''}
    ${p.nota ? `Explicatii privind instrumentul de ${p.nota}<br/>` : ''}
    ${p.iban ? `Nr. cont de plata &nbsp;&nbsp; ${p.iban}<br/>` : ''}
    ${p.banca ? `Numele contului de &nbsp;&nbsp; ${p.banca}<br/>` : ''}
  </div>`).join('')}
</div>` : '';

		// Nr. intrare registru header
		const nrIntrareHtml = `
<div style="text-align:center;margin:10px 0;padding:8px;border:2px solid #1976d2;border-radius:4px;background:#e3f2fd">
  <span style="font-size:15px;font-weight:bold;color:#1976d2">Numar intrare registru: ${row.nr_intern}</span>
  &nbsp;&nbsp;
  <span style="font-size:13px;color:#555">Data inregistrare: ${row.data_primirii}</span>
</div>`;

		return `
${nrIntrareHtml}
<div style="display:flex;gap:20px;justify-content:space-between;flex-wrap:wrap;margin-top:8px">
  ${vanzatorHtml}
  ${facturaCentruHtml}
  ${cumparatorHtml}
</div>
${totaluriHtml}
${tvaHtml}
${liniiHtml}
${plataHtml}
${f.nota ? `<div style="margin-top:10px;font-size:12px"><b>Nota:</b><br/>${f.nota}</div>` : ''}`;
	}

	const handlePrint = (row) => {
		const url = "getLiniiFacturaRegistru?session_id=" + props.session.sessId;
		fetch_url_post(url, {id: row.id}, (result) => {
			const f = (result && result.factura) ? result.factura : {};
			const bodyHtml = buildFacturaHtml(row, f);
			const win = window.open('', '_blank', 'width=1000,height=950');
			win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"/>
<title>RO eFactura - ${f.numar_factura||row.nr_factura}</title>
<style>
  body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; color: #222; }
  table { border-collapse: collapse; }
  table td, table th { vertical-align: top; }
  @media print { .no-print { display: none; } body { margin: 10px; } }
</style>
</head><body>
${bodyHtml}
<div style="margin-top:30px;font-size:10px;color:#aaa;text-align:center">Tiparit din Sistem ERP &mdash; ${new Date().toLocaleString('ro-RO')}</div>
<div class="no-print" style="text-align:center;margin-top:16px">
  <button onclick="window.print()" style="padding:8px 24px;font-size:14px;cursor:pointer">Tipareste / Salveaza PDF</button>
</div>
</body></html>`);
			win.document.close();
			win.focus();
		}, () => {});
	}

	const handleDownloadXmlArchive = () => {
		const url = get_api_path() + "downloadXmlArchive?session_id=" + props.session.sessId + "&period=" + xmlPeriod;
		window.open(url, "_blank");
	};

	const handleBulkPrint = () => {
		if (!selectedRows || selectedRows.length === 0) {
			setMessageText("Selectati cel putin o factura pentru tiparire!");
			return;
		}
		const url = "getLiniiFacturaRegistru?session_id=" + props.session.sessId;
		const results = {};
		let pending = selectedRows.length;
		const doOpen = () => {
			const allHtml = selectedRows.map(row => {
				const f = results[row.id] || {};
				return buildFacturaHtml(row, f);
			}).join('<div style="page-break-after:always;border-top:2px dashed #ccc;margin:30px 0"></div>');
			const win = window.open('', '_blank', 'width=1000,height=950');
			win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"/>
<title>Tiparire facturi (${selectedRows.length})</title>
<style>
  body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; color: #222; }
  table { border-collapse: collapse; }
  table td, table th { vertical-align: top; }
  @media print { .no-print { display: none; } body { margin: 10px; } }
</style>
</head><body>
${allHtml}
<div style="margin-top:30px;font-size:10px;color:#aaa;text-align:center">Tiparit din Sistem ERP &mdash; ${new Date().toLocaleString('ro-RO')}</div>
<div class="no-print" style="text-align:center;margin-top:16px">
  <button onclick="window.print()" style="padding:8px 24px;font-size:14px;cursor:pointer">Tipareste / Salveaza PDF</button>
</div>
</body></html>`);
			win.document.close();
			win.focus();
		};
		selectedRows.forEach(row => {
			fetch_url_post(url, {id: row.id}, (result) => {
				results[row.id] = (result && result.factura) ? result.factura : {};
				pending--;
				if (pending === 0) doOpen();
			}, () => {
				results[row.id] = {};
				pending--;
				if (pending === 0) doOpen();
			});
		});
	}

	const handlePrintRegistru = () => {
		const list = filteredList;
		const titluAn = filterYear ? ` - An ${filterYear}` : '';
		const rowsHtml = list.map((row, idx) => `<tr style="background:${idx%2===0?'#fff':'#f9f9f9'}">
  <td style="padding:4px 6px;border:1px solid #ddd;text-align:center">${idx+1}</td>
  <td style="padding:4px 6px;border:1px solid #ddd">${row.nr_intern||''}</td>
  <td style="padding:4px 6px;border:1px solid #ddd">${row.data_primirii||''}</td>
  <td style="padding:4px 6px;border:1px solid #ddd">${row.furnizor||''}</td>
  <td style="padding:4px 6px;border:1px solid #ddd">${row.nr_factura||''}</td>
  <td style="padding:4px 6px;border:1px solid #ddd;text-align:right">${parseFloat(row.valoare||0).toFixed(2)}</td>
  <td style="padding:4px 6px;border:1px solid #ddd;text-align:right">${parseFloat(row.tva||0).toFixed(2)}</td>
  <td style="padding:4px 6px;border:1px solid #ddd;text-align:right"><b>${parseFloat(row.total||0).toFixed(2)}</b></td>
  <td style="padding:4px 6px;border:1px solid #ddd">${row.efactura_id ? 'e-Factura' : (row.observatii||'')}</td>
</tr>`).join('');
		const totalGeneral = list.reduce((s, r) => s + parseFloat(r.total||0), 0);
		const win = window.open('', '_blank', 'width=1100,height=900');
		win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"/>
<title>Registru Intrari${titluAn}</title>
<style>
  body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; color: #222; }
  table { border-collapse: collapse; width: 100%; }
  th { background: #e3f2fd; padding: 5px 6px; border: 1px solid #ddd; }
  @media print { .no-print { display: none; } body { margin: 10px; } }
</style>
</head><body>
<div style="text-align:center;margin-bottom:12px">
  <h2 style="margin:4px 0">${unitData.name||''}</h2>
  <h3 style="margin:4px 0;color:#555">CIF: ${unitData.fiscal_code||''} &mdash; ${unitData.address||''}</h3>
  <h3 style="margin:8px 0">REGISTRU FACTURI INTRARI${titluAn}</h3>
</div>
<table>
  <thead><tr>
    <th style="width:35px">Nr.</th>
    <th>Nr. intern</th>
    <th>Data primirii</th>
    <th>Furnizor</th>
    <th>Nr. factura furnizor</th>
    <th>Valoare fara TVA</th>
    <th>TVA</th>
    <th>Total RON</th>
    <th>Observatii</th>
  </tr></thead>
  <tbody>${rowsHtml}</tbody>
  <tfoot><tr>
    <td colspan="7" style="padding:5px 6px;border:1px solid #ddd;font-weight:bold;text-align:right">TOTAL GENERAL:</td>
    <td style="padding:5px 6px;border:1px solid #ddd;font-weight:bold;text-align:right">${totalGeneral.toFixed(2)}</td>
    <td style="border:none"></td>
  </tr></tfoot>
</table>
<div style="margin-top:30px;font-size:10px;color:#aaa;text-align:center">Tiparit din Sistem ERP &mdash; ${new Date().toLocaleString('ro-RO')} | Total inregistrari: ${list.length}</div>
<div class="no-print" style="text-align:center;margin-top:16px">
  <button onclick="window.print()" style="padding:8px 24px;font-size:14px;cursor:pointer">Tipareste / Salveaza PDF</button>
</div>
</body></html>`);
		win.document.close();
		win.focus();
	}

	const actionsTemplate = (row) => (
		<React.Fragment>
			<Button icon="pi pi-print" className="p-button-sm p-button-secondary p-button-text" style={{marginRight:"2px"}}
				tooltip="Tipareste" tooltipOptions={{position:"top"}}
				onClick={() => handlePrint(row)}/>
			<Button icon="pi pi-pencil" className="p-button-sm p-button-info p-button-text" style={{marginRight:"4px"}}
				tooltip="Modifica" tooltipOptions={{position:"top"}}
				onClick={() => handleEdit(row)}/>
			<Button icon="pi pi-trash" className="p-button-sm p-button-danger p-button-text"
				tooltip="Sterge" tooltipOptions={{position:"top"}}
				onClick={() => handleDelete(row)}/>
		</React.Fragment>
	);

	const totalTemplate = (row) => (
		<span style={{fontWeight:"bold"}}>
			{parseFloat(row.total).toFixed(2)} {row.moneda || "RON"}
		</span>
	);

	const rowStyle = (data) => {
		if(data.efactura_id) return {"backgroundColor": "#f0fff4"};
		return {};
	};

	return(
		<BlockUI blocked={blockScreen} fullScreen>
			<ConfirmDialog/>
			{!!(!dataOk) && <LinearProgress/>}
			{messageText && <Message text={messageText} closeHandler={() => setMessageText(null)}/>}

			<Grid container spacing={1} style={{padding:"8px"}}>
				{/* Toolbar */}
				<Grid item xs={12}>
					<div style={{display:"flex", gap:"8px", alignItems:"center", flexWrap:"wrap", marginBottom:"8px"}}>
						<Button label="Adauga inregistrare" icon="pi pi-plus"
							className="p-button-sm p-button-success p-button-raised"
							onClick={handleAddNew}/>				{selectedRows.length > 0 &&
					<Button label={`Tipareste selectate (${selectedRows.length})`} icon="pi pi-print"
						className="p-button-sm p-button-secondary p-button-raised"
						onClick={handleBulkPrint}/>
				}
				<Button label="Tipareste registrul" icon="pi pi-list"
					className="p-button-sm p-button-help p-button-raised"
					onClick={handlePrintRegistru}/>
				<span style={{display:"inline-flex", alignItems:"center", gap:"4px", marginLeft:"8px"}}>
					<select value={xmlPeriod} onChange={(e) => setXmlPeriod(e.target.value)}
						style={{fontSize:"13px", padding:"4px 6px", borderRadius:"4px", border:"1px solid #ccc", height:"32px"}}>
						<option value="1">1 zi</option>
						<option value="7">7 zile</option>
						<option value="30">30 zile</option>
						<option value="all">Tot</option>
					</select>
					<Button label="Descarca arhiva XML" icon="pi pi-file-arrow-down"
						className="p-button-sm p-button-warning p-button-raised"
						onClick={handleDownloadXmlArchive}/>
				</span>						<span style={{marginLeft:"auto"}}>
							<InputText placeholder="Filtru: furnizor / nr. factura" value={filterText}
								onChange={(e) => setFilterText(e.target.value)}
								style={{width:"220px", marginRight:"6px"}} className="p-inputtext-sm"/>
							<InputText placeholder="An" value={filterYear}
								onChange={(e) => setFilterYear(e.target.value)}
								style={{width:"80px", marginRight:"6px"}} className="p-inputtext-sm"/>
							<Button label="Cauta" icon="pi pi-search"
								className="p-button-sm p-button-info p-button-raised"
								onClick={handleFilter}/>
						</span>
					</div>
				</Grid>

				{/* Table */}
				<Grid item xs={12}>
					<DataTable value={filteredList} paginator rows={25}
						rowsPerPageOptions={[10,25,50,100]}
						emptyMessage="Nu exista inregistrari"
						className="p-datatable-sm"
						rowClassName={rowStyle}
						sortField="id" sortOrder={-1}
					style={{fontSize:"13px"}}
					selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)}
					dataKey="id">
					<Column selectionMode="multiple" style={{width:"40px"}} headerStyle={{width:"40px"}}/>
						<Column field="nr_intern" header="Nr. intern" sortable style={{width:"130px"}}/>
						<Column field="data_primirii" header="Data primirii" sortable style={{width:"120px"}}/>
							<Column field="furnizor" header="Furnizor" sortable style={{width:"180px", maxWidth:"180px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}/>
						<Column field="nr_factura" header="Nr. factura furnizor" sortable style={{width:"170px"}}/>
						<Column field="valoare" header="Valoare (fara TVA)"
							body={(row) => parseFloat(row.valoare).toFixed(2)}
							sortable style={{width:"140px", textAlign:"right"}}/>
						<Column field="tva" header="TVA"
							body={(row) => parseFloat(row.tva).toFixed(2)}
							sortable style={{width:"90px", textAlign:"right"}}/>
						<Column field="total" header="Total RON" body={totalTemplate}
							sortable style={{width:"110px", textAlign:"right"}}/>
						<Column field="observatii" header="Observatii"
							body={(row) => row.efactura_id
								? <span>
									<Tag value="e-Factura" severity="success" style={{fontSize:"10px",marginRight:"4px"}}/>
										{row.efactura_anaf_id && <span style={{fontSize:"11px",color:"#555",marginRight:"4px"}}>SPV: {row.efactura_anaf_id}</span>}
								  </span>
								: row.observatii}/>
						<Column header="Actiuni" body={actionsTemplate} style={{width:"90px"}}/>
					</DataTable>
				</Grid>
			</Grid>

			{/* Add/Edit Dialog */}
			<Dialog header={dialogValues.titleAddEdit} visible={dialogValues.openAddEdit}
				style={{width:"580px"}} modal
				onHide={() => setDialogValues({...dialogValues, openAddEdit: false})}>
				<Grid container spacing={2} style={{padding:"8px"}}>
					{inputValues.nr_intern &&
						<Grid item xs={12}>
							<label style={{fontWeight:"bold", color:"#2196F3"}}>Nr. intern: {inputValues.nr_intern}</label>
						</Grid>
					}
					<Grid item xs={12} sm={6}>
						<label>Data primirii facturii *</label><br/>
						<Calendar value={inputValues.data_primirii} dateFormat="dd-mm-yy"
							onChange={(e) => handleCalendarChange("data_primirii", e.value)}
							style={{width:"100%"}} className="p-inputtext-sm"
							showIcon locale="ro"/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<label>Nr. factura furnizor *</label><br/>
						<InputText name="nr_factura" value={inputValues.nr_factura}
							onChange={handleChange} style={{width:"100%"}} className="p-inputtext-sm"/>
					</Grid>
					<Grid item xs={12}>
						<label>Furnizor *</label><br/>
						<InputText name="furnizor" value={inputValues.furnizor}
							onChange={handleChange} style={{width:"100%"}} className="p-inputtext-sm"/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<label>Valoare fara TVA (RON)</label><br/>
						<InputNumber value={inputValues.valoare} mode="decimal" minFractionDigits={2} maxFractionDigits={2}
							onValueChange={(e) => handleNumberChange("valoare", e.value || 0)}
							onBlur={tvaAutoCalc}
							style={{width:"100%"}} inputClassName="p-inputtext-sm"/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<label>TVA (RON)</label><br/>
						<InputNumber value={inputValues.tva} mode="decimal" minFractionDigits={2} maxFractionDigits={2}
							onValueChange={(e) => handleNumberChange("tva", e.value || 0)}
							onBlur={tvaAutoCalc}
							style={{width:"100%"}} inputClassName="p-inputtext-sm"/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<label>Total (RON)</label><br/>
						<InputNumber value={inputValues.total} mode="decimal" minFractionDigits={2} maxFractionDigits={2}
							onValueChange={(e) => handleNumberChange("total", e.value || 0)}
							style={{width:"100%"}} inputClassName="p-inputtext-sm"/>
					</Grid>
					<Grid item xs={12}>
						<label>Observatii</label><br/>
						<InputText name="observatii" value={inputValues.observatii}
							onChange={handleChange} style={{width:"100%"}} className="p-inputtext-sm"/>
					</Grid>
					<Grid item xs={12} style={{display:"flex", gap:"8px", justifyContent:"flex-end"}}>
						<Button label="Anuleaza" icon="pi pi-times"
							className="p-button-sm p-button-secondary"
							onClick={() => setDialogValues({...dialogValues, openAddEdit: false})}/>
						<Button label="Salveaza" icon="pi pi-save"
							className="p-button-sm p-button-success p-button-raised"
							onClick={handleSave}/>
					</Grid>
				</Grid>
			</Dialog>
		</BlockUI>
	);
}

export default RegistruIntrari;
